import ApiInstance from "../../config/intercepter";
import Api from "./../../config/api";
import { setHeaderType } from "../../helper/helper";

/** =========================
 *  INITIATE (processing fee)
 *  ========================= */

// Salary Advance: amount only
export function initiateSalaryAdvance(amount) {
  setHeaderType("application/json");
  return ApiInstance.post(Api.fetchRequestDetails, {
    amount,
    loanType: "salaryAdvance",
  });
}

// Salary Top-Up: amount + duration
export function initiateSalaryTopup(amount, duration) {
  setHeaderType("application/json");
  return ApiInstance.post(Api.fetchRequestDetails, {
    amount,
    loanType: "salaryTopUp",
    duration, // keep same unit the backend expects
  });
}

/** ==================================
 *  SUBMIT (create the actual request)
 *  ================================== */

// Salary Advance submit
export function submitSalaryAdvance({
  requestedAmount,
  interestAmount,
  salaryDueDate, // e.g. '2025-09-30'
  need,          // reason code or text
}) {
  const form = new FormData();
  form.append("requestedAmount", String(requestedAmount));
  form.append("interestAmount", String(interestAmount));
  form.append("salaryDueDate", salaryDueDate);
  form.append("loanType", "salaryAdvance");
  form.append("need", need);

  setHeaderType("multipart/form-data");
  return ApiInstance.post(Api.submitRequest, form);
}

// Salary Top-Up submit
export function submitSalaryTopup({
  requestedAmount,
  interestAmount,
  salaryDueDate,
  duration,
  need, // NOTE: backend currently expects `whyNeedMoney` for top-ups
}) {
  const form = new FormData();
  form.append("requestedAmount", String(requestedAmount));
  form.append("interestAmount", String(interestAmount));
  form.append("salaryDueDate", salaryDueDate);
  form.append("loanType", "salaryTopUp");
  form.append("duration", String(duration));
  // If/when backend is unified, change this to `need`
  form.append("whyNeedMoney", need);

  setHeaderType("multipart/form-data");
  return ApiInstance.post(Api.submitRequest, form);
}

/** Optional: one helper that covers both */
export function processRequestAmount(amount, loanType, duration) {
  setHeaderType("application/json");
  const body = { amount, loanType };
  if (loanType === "salaryTopUp" && duration != null) body.duration = duration;
  return ApiInstance.post(Api.fetchRequestDetails, body);
}
